__webpack_require__.p = "/migd-os/";